class ProductCardUpsell extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      addToCart: '[js-upsell-add-to-cart]',
      error: '[js-upsell-error-message]',
      cart: 'cart-drawer',
      cartDrawer: '#CartDrawer'
    }
  }

  connectedCallback() {
    this.addToCart = this.querySelector(this._selectors.addToCart);
    this.price = this.querySelector(this._selectors.price);
    this.cart = document.querySelector(this._selectors.cart);
    this.cartDrawer = document.querySelector(this._selectors.cartDrawer);

    this.addToCart.addEventListener('click', this._addToCart);
  }

  _addToCart = (evt) => {
    evt.preventDefault();
    console.log(evt)
    this._disableButton();

    const properties = this.dataset.properties;
    this.cart.setActiveElement(document.activeElement);
    let data; 

    if (properties != null) {
      data = {
        items: [{ id: evt.currentTarget.dataset.variantId, quantity: 1, properties: JSON.parse(properties) }],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      };
    } else {
      data = {
        items: [{ id: evt.currentTarget.dataset.variantId, quantity: 1}],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      };
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
		})
    .then((response) => response.text())
    .then((state) => {  
      const parsedState = JSON.parse(state);

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      const cartItems = document.querySelector('cart-drawer-items')
      cartItems.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer.connectedCallback();
    })
		.catch((e) => {
      console.log(e);
		})
    .finally(() => {
      this._enableButton();
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  _handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.querySelector(this._selectors.error)

    if (errorMessage) {
      this.errorMessageWrapper.innerHTML = errorMessage;
      this.errorMessageWrapper.classList.remove('hidden');
    } else {
      this.errorMessageWrapper.classList.add('hidden');
    }
  }

  _disableButton() {
    this.addToCart.setAttribute('disabled', '');
    this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.remove('hidden'));
  }

  _enableButton() {
    this.addToCart.removeAttribute('disabled');
    this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define("product-card-upsell", ProductCardUpsell);